import {getPrivateAxios} from '../../libs';

export interface DemoRequestDto {
  phone?: string;
  telegram?: string;
}

export const fetchDemoRequest = async (demoRequestDto: DemoRequestDto) => {
  const {data} = await getPrivateAxios().post('/feedback/demo-request', demoRequestDto);
  return data;
};
